import { FunctionComponent } from "react";

import theme from "@ui/themes/theme-contract.css";

/**
 * NoNotificationsFlag component that displays a flag icon.
 * Colors are dynamically set using theme CSS variables, which automatically
 * adapt to community-specific theme overrides.
 */
export const NoNotificationsFlag: FunctionComponent = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="54"
      viewBox="0 0 48 54"
      fill="none"
    >
      <rect
        width="1.5559"
        height="39.839"
        rx="0.777949"
        transform="matrix(0.999895 0.0144604 -0.00879314 0.999961 6.04724 6.3418)"
        fill={theme.sys.color.secondary}
      />
      <circle
        cx="1.59637"
        cy="1.59637"
        r="1.59637"
        transform="matrix(-0.999899 -0.0141841 -0.0141841 0.999899 8.66638 4.41211)"
        fill={theme.sys.color.secondary}
      />
      <path
        d="M19.022 11.8304C19.0261 11.2302 19.5468 10.6762 20.1335 10.6479L44.0971 9.49265C44.9042 9.45374 45.2447 10.388 44.6752 11.0789L37.0061 20.3823C36.6535 20.8101 36.6291 21.39 36.9497 21.7268L44.3282 29.4771C44.8965 30.0741 44.3279 31.2188 43.4418 31.2615L19.7481 32.4038C19.2539 32.4276 18.885 32.0655 18.8885 31.56L19.022 11.8304Z"
        fill={`color-mix(in srgb, ${theme.sys.color.primary} 80%, white)`}
      />
      <path
        d="M27.0861 8.47449C27.0909 7.76903 26.3936 7.40574 25.7451 7.77581L19.5608 11.3049C19.1834 11.5203 18.9335 11.9316 18.9307 12.3422L18.7989 31.8134C18.7955 32.3072 19.2836 32.5615 19.7376 32.3025L26.3272 28.5421C26.7046 28.3268 26.9545 27.9154 26.9573 27.5048L27.0861 8.47449Z"
        fill={`color-mix(in srgb, ${theme.sys.color.primary} 80%, black)`}
      />
      <path
        d="M6.03182 7.04088C6.03587 6.44287 6.55289 5.89026 7.13787 5.8587L26.3491 4.82206C26.8457 4.79527 27.2176 5.15794 27.2142 5.66556L27.0811 25.3132C27.0771 25.9112 26.5601 26.4638 25.9751 26.4954L6.76387 27.532C6.26731 27.5588 5.89536 27.1961 5.8988 26.6885L6.03182 7.04088Z"
        fill={theme.sys.color.primary}
      />
    </svg>
  );
};
